var _a, _b;
import ddt from '@wix/da-ddt';
import { handleActions } from 'redux-actions';
import { addNotification, removeNotification } from './actionCreators';
import { reduxKey } from './constants';
var handler = handleActions((_a = {},
    _a[addNotification.toString()] = function (state, action) {
        if (!action.payload) {
            ddt.warn('notifications', 'Notification add without payload');
            return state;
        }
        var queue = state || [];
        return queue.concat([action.payload]);
    },
    _a[removeNotification.toString()] = function (state, action) {
        if (action.payload === undefined) {
            ddt.warn('notifications', 'Notification remove without id');
            return state;
        }
        var queue = state || [];
        return queue.filter(function (item) { return item.id !== action.payload; });
    },
    _a), []);
export default (_b = {},
    _b[reduxKey] = handler,
    _b);
//# sourceMappingURL=reducer.js.map